import styled from 'styled-components';

export const ActionsContainer = styled.div`
	padding: 1rem 1rem 1.25rem;
	border-top: 1px solid var(--ion-color-step-900);
	background-color: #257226;//var(--ion-color-primary);
	margin-top: -1px;
	position: relative;
	z-index: 1;
`;

export const ActionGroup = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	background-color: #257226;
	/* background-color: var(--ion-color-step-550); */
	/* padding: 0 0.5rem; */
	border-radius: 10px;
`;

export const Action = styled.div`
	font-size: 10px;
	//text-transform: uppercase;
	color: #ffffff;//var(--ion-color-light-shade);
	font-weight: bold;
	flex: 0 20%;
	text-align: center;
`;

export const ActionSVG = styled.div`
	background-color: #1c4220;//var(--ion-color-primary-tint);
	padding: 0.5rem;
	width: 56px;
	margin: 0 auto 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	aspect-ratio: 1/1;
	border: 2px solid var(--ion-color-light-shade);
	box-shadow: var(--generic-box-shadow);
	svg {
		width: 60%;
		height: 60%;
		&[data-name='Navigate-Icon'] {
			margin-left: -3px;
			margin-top: 3px;
		}
		path {
			fill: #fff;
		}
	}
`;
